import React from 'react'

import {Spinner8} from '@styled-icons/icomoon/Spinner8'

const Loading = ({minHeightScreen, small, inline, percentage}) => <div className={`w-full h-full flex ${percentage ? 'flex-col gap-3' : ''} items-center justify-center text-pink-500 ${minHeightScreen ? 'min-h-screen' : ''} ${inline ? 'inline-flex px-2' : '' }`}>
                            <Spinner8 className={`animate-spin h-10 ${small ? 'h-4' : ''}`}/>
                            {percentage && percentage != "0%" && <div>{percentage}</div>}
                    </div>;

export default Loading;